import { render, staticRenderFns } from "./EvaluationDropzone.vue?vue&type=template&id=1840f119&scoped=true&"
import script from "./EvaluationDropzone.vue?vue&type=script&lang=js&"
export * from "./EvaluationDropzone.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationDropzone.vue?vue&type=style&index=0&id=1840f119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840f119",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BListGroupItem, BListGroup, BButton} from 'bootstrap-vue'
    installComponents(component, {BListGroupItem, BListGroup, BButton})
    

export default component.exports